export const pixedCloud = {
  id: "pixed-cloud",
  disciplines: "User Interface, Visual System",
  shortDisciplines: "UI, Visual System",
  year: 2024,
  project: "Pixed Cloud",
  initiatedAt: "FH Salzburg, Austria (Master)",
  shortInitiatedAt: "FHS, AT (MA)",
  thumbnailUrl: "/assets/Pixed/00-P-1x1-1440.webp",
  description:
    '"Pixed" is a shared album platform for collaborative image collections. The project focuses on a clear visual system and user interface based on a strict grid, reduced components, and consistent interaction patterns. The design prioritizes orientation and scalability, allowing content to organize itself while the interface remains deliberately restrained.',
  credits: [
    "Initiated at MA Communication Design, FH Salzburg, Austria",
    "Student Team Anna-Sophie Wehmeyer, Annika Braun",
  ],
  galleryItems: [
    {
      medias: [
        {
          type: "image",
          url: "/assets/Pixed/01-P-16x9-2560.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-twelve-lg landscape-media-sixteen-by-nine",
        },
      ],
      description: {
        text: "",
        classNames: "start-one-sm span-four-sm start-one-lg span-twelve-lg",
      },
    },
    {
      medias: [
        {
          type: "image",
          url: "/assets/Pixed/02-P-9x10-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-six-lg portrait-media-nine-by-ten",
        },
        {
          type: "image",
          url: "/assets/Pixed/03-P-9x10-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-seven-lg span-six-lg portrait-media-nine-by-ten",
        },
      ],
      description: {
        text: "",
        classNames: "start-one-sm span-four-sm start-one-lg span-twelve-lg",
      },
    },
    {
      medias: [
        {
          type: "image",
          url: "/assets/Pixed/04-P-1x1-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-six-lg square-media-one-by-one",
        },
        {
          type: "video",
          sound: true,
          url: "/assets/Pixed/05-P-1x1-1440.mp4",
          poster: "/assets/Pixed/05-P-1x1-1440_thumbnail.webp",
          classNames:
            "start-one-sm span-four-sm start-seven-lg span-six-lg square-media-one-by-one",
        },
      ],
      description: {
        text: "",
        classNames: "start-one-sm span-four-sm start-one-lg span-twelve-lg",
      },
    },
    {
      medias: [
        {
          type: "video",
          sound: true,
          url: "/assets/Pixed/06-P-1x1-Video.mp4",
          poster: "/assets/Pixed/06-P-1x1-Video_thumbnail.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-six-lg square-media-one-by-one",
        },
        {
          type: "image",
          url: "/assets/Pixed/07-P-1x1-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-seven-lg span-six-lg square-media-one-by-one",
        },
      ],
      description: {
        text: "",
        classNames: "start-one-sm span-four-sm start-one-lg span-twelve-lg",
      },
    },
    {
      medias: [
        {
          type: "video",
          sound: true,
          url: "/assets/Pixed/08-P-19x9-Video.mp4",
          poster: "/assets/Pixed/08-P-19x9-Video_thumbnail.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-twelve-lg landscape-media-sixteen-by-nine",
        },
      ],
      description: {
        text: "",
        classNames: "start-one-sm span-four-sm start-one-lg span-twelve-lg",
      },
    },
    {
      medias: [
        {
          type: "image",
          url: "/assets/Pixed/09-P-9x10-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-six-lg portrait-media-nine-by-ten",
        },
        {
          type: "image",
          url: "/assets/Pixed/10-P-9x10-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-seven-lg span-six-lg portrait-media-nine-by-ten",
        },
      ],
      description: {
        text: "",
        classNames: "start-one-sm span-four-sm start-one-lg span-twelve-lg",
      },
    },
    {
      medias: [
        {
          type: "video",
          sound: true,
          url: "/assets/Pixed/11-P-9x10-Video.mp4",
          poster: "/assets/Pixed/11-P-9x10-Video_thumbnail.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-six-lg portrait-media-nine-by-ten",
        },
        {
          type: "image",
          url: "/assets/Pixed/12-P-9x10-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-seven-lg span-six-lg portrait-media-nine-by-ten",
        },
      ],
      description: {
        text: "",
        classNames: "start-one-sm span-four-sm start-one-lg span-twelve-lg",
      },
    },
  ],
};
